import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
interface Props {
  isActive?: boolean;
  isOverviewPage?: boolean;
}

const Buttons = styled.div<Props>`
  display: flex;
  padding: var(--space-20) var(--space-20) var(--space-24);
  ${(props) =>
    props.isOverviewPage &&
    css`
      display: none;
    `}
  ${mobile_xl(css`
    padding: var(--space-16) var(--space-16) var(--space-24);
  `)}
`;

const Content = styled.div<Props>`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  .reports-time-empty {
    margin: var(--space-0) auto var(--space-24);
    ${mobile_xl(css`
      margin-bottom: var(--space-16);
    `)}
  }
  ${(props) =>
    props.isOverviewPage &&
    css`
      border: none;
      border-radius: unset;
    `}
`;
export { Buttons, Content };
